import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";

const ModalFormPerangkat = ({
  isOpen,
  toggle,
  form,
  handleInputChange,
  handleFileChange,
  handleConfirm,
  isEditing,
  agamaList = [],
  etnisList = [],
  statusHubunganKeluargaList = [],
  statusKewarganegaraanList = [],
  statusPerkawinanList = [],
  pendidikanList = [],
  pekerjaanList = [],
}) => {
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
      <ModalHeader toggle={toggle} className="fw-bold">
        {isEditing
          ? "📝 Edit Data Perangkat Desa"
          : "➕ Tambah Data Perangkat Desa"}
      </ModalHeader>
      <Form onSubmit={handleConfirm}>
        <ModalBody className="px-4">
          <h6 className="text-primary fw-bold mb-3">Data Diri</h6>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> NIK :
                </Label>
                <Input
                  type="text"
                  name="nik"
                  value={form.nik || ""}
                  onChange={handleInputChange}
                  placeholder="Masukkan 16 digit NIK"
                  required
                  maxLength="16"
                  pattern="\d*"
                  minLength="16"
                />
                {form.nik && form.nik.length > 0 && form.nik.length < 16 && (
                  <small className="text-danger">
                    NIK harus 16 digit (Kurang {16 - form.nik.length} lagi)
                  </small>
                )}
              </FormGroup>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> No. Kartu Keluarga :
                </Label>
                <Input
                  type="text"
                  name="nomorKk"
                  value={form.nomorKk || ""}
                  onChange={handleInputChange}
                  placeholder="Masukkan Nomor Kartu Keluarga"
                  required
                  pattern="\d*"
                  inputMode="numeric"
                  maxLength="16"
                />
              </FormGroup>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> Nama Lengkap :
                </Label>
                <Input
                  type="text"
                  name="nama"
                  value={form.nama || ""}
                  onChange={handleInputChange}
                  placeholder="Nama Lengkap"
                  required
                />
              </FormGroup>

              {/* Jenis Kelamin Tetap Radio */}
              <FormGroup tag="fieldset">
                <Label className="fw-bold small">
                  <span className="text-danger">*</span> Jenis Kelamin :
                </Label>
                <div className="d-flex align-items-center mt-2">
                  <FormGroup check inline className="mb-0 me-4">
                    <Input
                      type="radio"
                      id="laki"
                      name="jenisKelamin"
                      value="L"
                      onChange={handleInputChange}
                      checked={form.jenisKelamin === "L"}
                    />
                    <Label check for="laki" className="small ms-2">
                      Laki-laki
                    </Label>
                  </FormGroup>
                  <FormGroup check inline className="mb-0">
                    <Input
                      type="radio"
                      id="perempuan"
                      name="jenisKelamin"
                      value="P"
                      onChange={handleInputChange}
                      checked={form.jenisKelamin === "P"}
                    />
                    <Label check for="perempuan" className="small ms-2">
                      Perempuan
                    </Label>
                  </FormGroup>
                </div>
              </FormGroup>

              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> Tempat Lahir :
                </Label>
                <Input
                  type="text"
                  name="tempatLahir"
                  value={form.tempatLahir || ""}
                  onChange={handleInputChange}
                  placeholder="Tempat Lahir"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Tanggal Lahir :
                </Label>
                <Input
                  type="date"
                  name="tanggalLahir"
                  value={formatDate(form.tanggalLahir)} // Paksa format ke YYYY-MM-DD
                  onChange={handleInputChange}
                  required
                />
              </FormGroup>

              {/* DROPDOWN AGAMA (DYNAMIC) */}
              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Agama :
                </Label>
                <Input
                  type="select"
                  name="magamaId" // Sesuaikan dengan key database Anda
                  value={form.magamaId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Agama--</option>
                  {agamaList.map((item) => (
                    <option key={item.magamaId} value={item.magamaId}>
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              {/* DROPDOWN ETNIS/SUKU (DYNAMIC) */}
              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Suku/Etnis :
                </Label>
                <Input
                  type="select"
                  name="metnisId"
                  value={form.metnisId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Suku--</option>
                  {etnisList.map((item) => (
                    <option key={item.metnisId} value={item.metnisId}>
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label className="small fw-bold">Golongan Darah :</Label>
                <Input
                  type="select"
                  name="golonganDarah"
                  value={form.golonganDarah || ""}
                  onChange={handleInputChange}
                >
                  <option value="">--Pilih--</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="AB">AB</option>
                  <option value="O">O</option>
                  <option value="-">-</option>
                </Input>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> Nama Ibu Kandung :
                </Label>
                <Input
                  type="text"
                  name="namaIbuKandung"
                  value={form.namaIbuKandung || ""}
                  onChange={handleInputChange}
                  placeholder="Nama Ibu Kandung"
                  required
                />
              </FormGroup>

              {/* STATUS KELUARGA (DYNAMIC) */}
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> Status Hubungan
                  Keluarga :
                </Label>
                <Input
                  type="select"
                  name="mstatusHubunganKeluargaId"
                  value={form.mstatusHubunganKeluargaId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Status--</option>
                  {statusHubunganKeluargaList.map((item) => (
                    <option
                      key={item.mstatusHubunganKeluargaId}
                      value={item.mstatusHubunganKeluargaId}
                    >
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              {/* KEWARGANEGARAAN (DYNAMIC) */}
              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Kewarganegaraan :
                </Label>
                <Input
                  type="select"
                  name="mstatusKewarganegaraanId"
                  value={form.mstatusKewarganegaraanId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Kewarganegaraan--</option>
                  {statusKewarganegaraanList.map((item) => (
                    <option
                      key={item.mstatusKewarganegaraanId}
                      value={item.mstatusKewarganegaraanId}
                    >
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Status Perkawinan :
                </Label>
                <Input
                  type="select"
                  name="mstatusPerkawinanId"
                  value={form.mstatusPerkawinanId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Status--</option>
                  {statusPerkawinanList.map((item) => (
                    <option
                      key={item.mstatusPerkawinanId}
                      value={item.mstatusPerkawinanId}
                    >
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              {/* PENDIDIKAN (DYNAMIC) */}
              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Pendidikan Terakhir :
                </Label>
                <Input
                  type="select"
                  name="mpendidikanId"
                  value={form.mpendidikanId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Pendidikan--</option>
                  {pendidikanList.map((item) => (
                    <option key={item.mpendidikanId} value={item.mpendidikanId}>
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              {/* PEKERJAAN (DYNAMIC) */}
              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Pekerjaan :
                </Label>
                <Input
                  type="select"
                  name="mpekerjaanId"
                  value={form.mpekerjaanId || ""}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">--Pilih Pekerjaan--</option>
                  {pekerjaanList.map((item) => (
                    <option key={item.mpekerjaanId} value={item.mpekerjaanId}>
                      {item.nama}
                    </option>
                  ))}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label className="small">No. HP :</Label>
                <Input
                  type="text"
                  name="nomorHp"
                  value={form.nomorHp || ""}
                  onChange={handleInputChange}
                  placeholder="0812..."
                />
              </FormGroup>
              <FormGroup>
                <Label className="small fw-bold">Email :</Label>
                <Input
                  type="email"
                  name="email"
                  value={form.email || ""}
                  onChange={handleInputChange}
                  placeholder="contoh@mail.com"
                />
              </FormGroup>

              <FormGroup>
                <Label className="small fw-bold">
                  <span className="text-danger">*</span> Upload Foto :
                </Label>
                <Input
                  type="file"
                  name="foto"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e.target.files[0])}
                  required={!isEditing} // Wajib hanya saat tambah baru
                />
              </FormGroup>
            </Col>
          </Row>

          <h6 className="text-primary fw-bold mt-3 mb-3">Data Alamat</h6>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> Alamat :
                </Label>
                <Input
                  type="textarea"
                  name="alamat"
                  value={form.alamat || ""}
                  onChange={handleInputChange}
                  placeholder="Tulis alamat detail..."
                  required
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> RT :
                </Label>
                <Input
                  type="text"
                  name="rt"
                  value={form.rt || ""}
                  onChange={handleInputChange}
                  placeholder="Contoh: 001"
                  required
                  maxLength="3"
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label className="small">
                  <span className="text-danger">*</span> RW :
                </Label>
                <Input
                  type="text"
                  name="rw"
                  value={form.rw || ""}
                  onChange={handleInputChange}
                  placeholder="Contoh: 005"
                  required
                  maxLength="3"
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size="sm" onClick={toggle}>
            Batal
          </Button>
          <Button size="sm" color="primary" type="submit">
            {isEditing ? "Simpan Perubahan" : "Tambah Data"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ModalFormPerangkat;
